import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import shellapi from 'a365-shell-api';
import { confirmDialogSize, IConfirmDialogData } from 'app/shared/components/confirm-dialog/confirm-dialog.model';
import { format } from 'app/shared/utils/string.util';
import { MetaComponent } from 'app/components/base/component';

function noop(): void {
  //
}

@Injectable({
  providedIn: 'root'
})
export class GrantAuthDialogService {
  constructor(
    private readonly _dialog: MatDialog,
    private readonly _snackBar: MatSnackBar
  ) {
    //
  }

  public openDialog(handleOnOk: () => void = noop, handleOnCancel: () => void = noop): void {
    const confirmDialogComponentClass = MetaComponent.componentByName('ConfirmDialogComponent');

    const data: IConfirmDialogData = {
      title: stringResources.GrantAuthenticationTitle,
      content: format(stringResources.GrantAuthenticationContent, __IS_A365__ ? stringResources.Synapse : stringResources.AzureDataFactory),
      okButtonText: stringResources.Authenticate,
      progressText: stringResources.Processing,
      okCallback: () => {
        handleOnOk();
      },
      cancelCallback: () => {
        this._showToast({
          mode: 'error',
          header: stringResources.Error,
          message: stringResources.GrantAuthenticationDenyError,
          duration: 24 * 3600 * 1000 // give a long time to make sure customers notice the result of their action to cancel authentication
        });
        handleOnCancel();
      }
    };

    this._dialog.open(confirmDialogComponentClass, {
      disableClose: true,
      panelClass: 'confirm-dialog-panel-small',
      width: confirmDialogSize.small,
      data
    });
  }

  private _showToast(config: shellapi.notifications.IToastConfig): void {
    const toastComponentClass = MetaComponent.componentByName('ToastComponent');

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const snackBarRef: MatSnackBarRef<any> = this._snackBar.openFromComponent(toastComponentClass, {
      panelClass: 'app-toast-panel',
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: config.duration || 5000,
      data: {
        mode: config.mode,
        header: config.header,
        message: config.message,
        buttons: config.buttons,
        closeCallback: config.closeCallback || (() => snackBarRef.dismiss()),
        id: config.id,
        hyperlinkText: config.hyperlinkText,
        hyperlinkCallback: config.hyperlinkCallback,
        showRedirectIcon: config.showRedirectIcon
      }
    });
  }
}
